const API = process.env.REACT_APP_BACKEND_URL;
let pixelId = null;
let loaded = false;

export async function setupMeta() {
    try {
        const res = await fetch(`${API}/api/config`);
        const cfg = await res.json();
        if (!cfg.pixel_id) return;
        pixelId = cfg.pixel_id;
        loadPixel(pixelId);
        trackBoth("PageView", {});
    } catch (e) {
        /* tracking is optional; never block UX */
    }
}

function loadPixel(id) {
    if (loaded || window.fbq) return;
    loaded = true;
    const f = window;
    const b = document;
    const n = (f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    const t = b.createElement("script");
    t.async = true;
    t.src = "https://connect.facebook.net/en_US/fbevents.js";
    const s = b.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(t, s);
    f.fbq("init", id);
}

/**
 * Fire an event on BOTH browser pixel and server-side CAPI with the SAME event_id
 * so Meta can deduplicate (browser + server share eventID).
 */
export function trackBoth(name, data = {}) {
    const id = crypto.randomUUID();
    if (pixelId && window.fbq) window.fbq("track", name, data, { eventID: id });
    fetch(`${API}/api/tracking/event`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            event_name: name,
            event_id: id,
            event_source_url: window.location.href,
            custom_data: data,
        }),
    }).catch(() => {});
    return id;
}

export function trackBrowserPurchase(eventId, value, numItems, contents = [], contentIds = []) {
    if (pixelId && window.fbq) {
        window.fbq(
            "track",
            "Purchase",
            {
                value,
                currency: "BDT",
                content_ids: contentIds.length ? contentIds : ["khadi-punjabi"],
                content_type: "product",
                num_items: numItems,
                contents: contents.length ? contents : undefined,
            },
            { eventID: eventId },
        );
    }
}
